import { useCallback, useLayoutEffect, useRef } from 'react';

const BOTTOM_RESUME_THRESHOLD_PX = 4;

const useBottomScrollAnchor = ({ containerRef, contentKey, isActive, isPaused = false, thresholdPx = 80 }) => {
    const shouldAnchorToBottomRef = useRef(true);
    const isUserPausedRef = useRef(false);

    useLayoutEffect(() => {
        if (!containerRef.current || isPaused || !shouldAnchorToBottomRef.current || !isActive) return;

        containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }, [containerRef, contentKey, isActive, isPaused]);

    const updateBottomScrollAnchor = useCallback(
        (element) => {
            const distanceFromBottom = element.scrollHeight - element.scrollTop - element.clientHeight;

            if (isUserPausedRef.current) {
                shouldAnchorToBottomRef.current = distanceFromBottom <= BOTTOM_RESUME_THRESHOLD_PX;
                isUserPausedRef.current = !shouldAnchorToBottomRef.current;
                return;
            }

            shouldAnchorToBottomRef.current = distanceFromBottom <= thresholdPx;
        },
        [thresholdPx]
    );

    const pauseBottomScrollAnchor = useCallback(() => {
        isUserPausedRef.current = true;
        shouldAnchorToBottomRef.current = false;
    }, []);

    const resumeBottomScrollAnchor = useCallback(() => {
        isUserPausedRef.current = false;
        shouldAnchorToBottomRef.current = true;
    }, []);

    return {
        pauseBottomScrollAnchor,
        resumeBottomScrollAnchor,
        updateBottomScrollAnchor,
    };
};

export default useBottomScrollAnchor;
